<script lang="ts">
  import Button from './Button.svelte';
  import Dialog from './Dialog.svelte';
  import { profileBlockDelay } from './profile-block-delay';

  let {
    open,
    blockedUntil,
    blockMessage,
    featureScoped,
    backToHome,
    expired,
  }: {
    open: boolean;
    blockedUntil: number | null;
    blockMessage: string | null;
    featureScoped: boolean;
    backToHome: () => void;
    expired: () => void;
  } = $props();

  let now = $state(Date.now());
  let notifiedFor = $state<number | null>(null);
  const expiry = $derived(blockedUntil === null ? '' : new Date(blockedUntil).toISOString());
  const expiryLabel = $derived(
    blockedUntil === null
      ? ''
      : new Intl.DateTimeFormat(undefined, {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          timeZoneName: 'short',
        }).format(blockedUntil),
  );

  $effect(() => {
    if (blockedUntil === null) {
      notifiedFor = null;
      return;
    }
    if (blockedUntil <= Date.now()) {
      now = Date.now();
      if (notifiedFor !== blockedUntil) {
        notifiedFor = blockedUntil;
        expired();
      }
      return;
    }
    now = Date.now();
    const timeout = setTimeout(
      () => {
        now = Date.now();
      },
      profileBlockDelay(blockedUntil, now),
    );
    return () => clearTimeout(timeout);
  });
</script>

<Dialog {open} labelledby="profile-block-title" required>
  <section class="profile-block-message">
    <h1 id="profile-block-title">BANNED!</h1>
    <p>{blockMessage?.trim() || 'This profile cannot play Spellie right now.'}</p>
    <p>
      You can {featureScoped ? 'use this feature' : 'play again'} after
      <time datetime={expiry}>{expiryLabel}</time>.
    </p>
    {#if featureScoped}<Button onclick={backToHome}>Back to Home</Button>{/if}
  </section>
</Dialog>

<style>
  .profile-block-message {
    display: grid;
    gap: 12px;
    text-align: center;
  }
  h1,
  p {
    margin: 0;
    overflow-wrap: anywhere;
  }
</style>
